import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const BulkResendLabelsResultSchema_ = z.object({
  returnId: z.string(),
  success: z.boolean(),
  message: z.string(),
});
export interface BulkResendLabelsResult
  extends z.infer<typeof BulkResendLabelsResultSchema_> {}
export const BulkResendLabelsResultSchema: z.ZodType<BulkResendLabelsResult> =
  BulkResendLabelsResultSchema_;

export const bulkResendLabels = unaryRpc({
  name: "bulkResendLabels",
  input: z.object({ returnIds: z.array(z.string()) }),
  output: z.object({ results: z.array(BulkResendLabelsResultSchema) }),
});
